import React from "react";
import { questionType } from "../../../constants";
import { Select } from "antd";
import { DropDownIcon } from "../../drop-down-icon";
import { useAppSelector } from "../../../modal/hooks";

type ComponentProps = {
	value: number | null;
	handleChange(e: number): void;
};

export const QuesTypeWeightageDropDown: React.FunctionComponent<ComponentProps> = (props) => {
	const { Option } = Select;
	const tableData = useAppSelector((store) => store.settings.queTypeAndWeightage);

	return (
		<Select
			className="data_selector form_input"
			placeholder="Select question type"
			value={props.value}
			onChange={(value) => props.handleChange(value)}
			showSearch
			suffixIcon={<DropDownIcon />}
			allowClear
		>
			{tableData.map((item, i) => (
				<Option key={`question_type_${i}`} value={item.id}>
					{item.name} - {item.weightage}
				</Option>
			))}
		</Select>
	);
};
